module.exports = __webpack_public_path__ + "32e1e21c678fefa452f09e384e8d7a91.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1041
// module chunks = 0